import { Input } from "basis";

export const validatePaymentAmount = (value, data): string | null => {
  const errors = Input.DEFAULT_PROPS.validate(value, data);

  if (errors !== null) {
    return errors;
  }

  const intValue = +value;

  if (intValue < 10) {
    return "Must be at least $10";
  }

  if (intValue > 99999) {
    return "Must be lower than $99,999";
  }

  return null;
};
